import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import News from './pages/News';
import PressRelease from './pages/PressRelease';
import AboutUs from './pages/AboutUs';
import Careers from './pages/Careers';
import PartsolGroup from './pages/PartsolGroup';
import Products from './pages/Products';
import Contact from './pages/Contact';
import Services from './pages/Services';
import TrustCenter from './pages/TrustCenter';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Controls from './pages/Controls';
import ScrollToTop from './components/ScrollToTop';
import Admin from './pages/Admin';

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';

  return (
    <div className="App">
      {!isAdminPage && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/press-release/:id" element={<PressRelease />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/partsol-group" element={<PartsolGroup />} />
        <Route path="/products" element={<Products />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/trust-center" element={<TrustCenter />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/trust-center/controls" element={<Controls />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      {!isAdminPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
      <Analytics />
    </Router>
  );
}

export default App;
